import React, { useState } from 'react';
import { GasPriceTracker } from './price-trackers/GasPriceTracker';
import { EggPriceTracker } from './price-trackers/EggPriceTracker';
import { DarkModeToggle } from './shared/DarkModeToggle';
import { useDarkMode } from '../hooks/useDarkMode';
import './Dashboard.css';

const Dashboard = () => {
  const { isDark, toggle } = useDarkMode();
  const [eggLastUpdated, setEggLastUpdated] = useState(null);
  const [gasLastUpdated, setGasLastUpdated] = useState(null);

  const lastUpdated = [eggLastUpdated, gasLastUpdated]
    .filter(Boolean)
    .map(d => new Date(d))
    .sort((a, b) => b - a)[0];

  return (
    <div className="dashboard">
      <div className="dashboard-container">
        <header className="dashboard-header">
          <h1 className="dashboard-title">Price tracking dashboard</h1>
          <div className="dashboard-header-right">
            {lastUpdated && (
              <span className="dashboard-last-updated">
                Last updated {lastUpdated.toLocaleDateString(undefined, {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })}
              </span>
            )}
            <DarkModeToggle isDark={isDark} onToggle={toggle} />
          </div>
        </header>

        <main className="dashboard-main">
          <EggPriceTracker isDark={isDark} onLastUpdatedChange={setEggLastUpdated} />
          <GasPriceTracker isDark={isDark} onLastUpdatedChange={setGasLastUpdated} />
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
